// extracted by mini-css-extract-plugin
module.exports = {"modal":"ItemPreviewDesktop-modal-3e44"};